import React from 'react';
import styled from 'styled-components';
import colors from '../utils/colors';

class Firma extends React.Component {
  render() {
    const Fh6 = styled.h6`
      color: ${colors.oscuro};
      font-weight: 600;
      font-size: 0.9em;
    `;

    const Fecha = styled.span`
      color: ${colors.oscuro};
      font-weight: 300;
      font-size: 0.8em;
      padding-left: 1em;
    `;

    return (
      <div>
        <Fh6>
          Por {this.props.contenido} <Fecha> {this.props.fecha} </Fecha>
        </Fh6>
      </div>
    );
  }
}

export default Firma;



// WEBPACK FOOTER //
// ./src/components/Firma.js